var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchairPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49414 3.5C4.49414 2.52875 5.27289 1.75 6.24414 1.75C7.21539 1.75 7.99414 2.52875 7.99414 3.5C7.99414 4.47125 7.21539 5.25 6.24414 5.25C5.27289 5.25 4.49414 4.47125 4.49414 3.5ZM9.30664 9.58125V7.875C9.30664 6.9125 8.51914 6.125 7.55664 6.125H4.93164C3.96914 6.125 3.18164 6.9125 3.18164 7.875V13.125H4.93164V19.25H7.99414V19.1537C6.90914 18.0512 6.24414 16.5375 6.24414 14.875C6.24414 12.6175 7.47789 10.64 9.30664 9.58125ZM14.9941 14.875C14.9941 16.3188 13.8129 17.5 12.3691 17.5C10.9254 17.5 9.74414 16.3188 9.74414 14.875C9.74414 13.9038 10.2779 13.0725 11.0566 12.6175V10.7275C9.28914 11.2875 7.99414 12.9237 7.99414 14.875C7.99414 17.29 9.95414 19.25 12.3691 19.25C14.7841 19.25 16.7441 17.29 16.7441 14.875H14.9941ZM17.6541 12.25H13.6816V7H11.9316V14H16.7091L18.8704 17.2462L20.3229 16.275L17.6541 12.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairPickup);
export default __webpack_public_path__ + "static/media/WheelchairPickup.913dd97fde9a41e31af3b5de7ac17250.svg";
export { ForwardRef as ReactComponent };